const Marquee3k = require('marquee3000/marquee3k.min'); // Loading minified version because the source file breaks uglify.js
const $body = theme.$body;
if ($('.brands-container--marquee').length) {
    if (typeof Array.from === 'function') {
        initMarquee();
    } else {
        // Need to load a polyfill if Array.from is not supported
        $body.append('<script src="https://cdn.polyfill.io/v2/polyfill.js?features=Array.from"></script>'); // Array.from polyfill for IE
        document.onreadystatechange = () => {
            initMarquee();
        };
    }
}

function initMarquee() {
    Marquee3k.init({
        selector: 'brands-container--marquee',
    });
}
